var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main Menu Icons/Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/house"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3335 14.6667H14.6668",
    stroke: "#4F4F4F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.9668 14.6667L2.00013 6.64665C2.00013 6.23998 2.19346 5.85335 2.51346 5.60002L7.18013 1.96668C7.66013 1.59334 8.33346 1.59334 8.82013 1.96668L13.4868 5.59334C13.8135 5.84668 14.0001 6.23332 14.0001 6.64665V14.6667",
    stroke: "#4F4F4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.66683 11.3333H7.3335C6.78016 11.3333 6.3335 11.78 6.3335 12.3333V14.6667H9.66683V12.3333C9.66683 11.78 9.22016 11.3333 8.66683 11.3333Z",
    stroke: "#4F4F4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/iconHome.99bfcc46184975ac5f5fa26b7abea931.svg";
export { ForwardRef as ReactComponent };